import { render, staticRenderFns } from "./ModalFirstGifts.vue?vue&type=template&id=33831ea0&"
import script from "./ModalFirstGifts.vue?vue&type=script&lang=js&"
export * from "./ModalFirstGifts.vue?vue&type=script&lang=js&"
import style0 from "./ModalFirstGifts.vue?vue&type=style&index=0&id=33831ea0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports